module.exports = __webpack_public_path__ + "img/SotS_Icon.2e802f7f.webp";